/**
 * standardTagRule模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios存储网关

const standardTagRule = {

  // 根据标准Tag Id查询规则
  queryRuleGroupByTagKeyId(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/standardTagRule/queryRuleGroupByTagKeyId`,param);
  }
}


export default standardTagRule;



// WEBPACK FOOTER //
// ./src/api/standardTagRule.js